import { __extends } from 'tslib';
import { ThirdPartyAdapter } from './thirdparty-adapter.esm.js';
import { appendQueryObject } from './url-util.esm.js';

var mapBoxApiAccessToken = 'pk.eyJ1IjoiZXhwZWRpYS1nZW8iLCJhIjoiY2w1anp3aXpuMDU3YTNibHY0Y21jazNteSJ9.fdrMME0LN_m9OEW_5v3sqA';
var MapboxAdapter = /** @class */ (function (_super) {
    __extends(MapboxAdapter, _super);
    function MapboxAdapter(locale, apiKey) {
        var _a;
        var _this = _super.call(this, locale) || this;
        _a = locale.split('_'), _this.language = _a[0], _this.locale = _a[1];
        _this.category = 'MAPBOX';
        _this.sourceName = 'mapbox';
        _this.type = 'address';
        _this.apiKey = apiKey || mapBoxApiAccessToken;
        return _this;
    }
    MapboxAdapter.getInstance = function (locale, apiKey) {
        var thisLocale = locale || 'en_US';
        var thisApiKey = apiKey || mapBoxApiAccessToken;
        if (!(thisLocale in this.instances)) {
            this.instances[thisLocale] = new MapboxAdapter(thisLocale, thisApiKey);
        }
        return this.instances[thisLocale];
    };
    MapboxAdapter.prototype.getGeocodingUrl = function (queryStr, param) {
        var endpoint = "https://api.mapbox.com/geocoding/v5/mapbox.places/".concat(queryStr, ".json?");
        return appendQueryObject(endpoint, param);
    };
    MapboxAdapter.prototype.fetchFromMapbox = function (queryStr) {
        var endpoint = this.getGeocodingUrl(queryStr, {
            autocomplete: true,
            language: this.language,
            types: this.type,
            fuzzyMatch: true,
            access_token: this.apiKey
        });
        return fetch(endpoint).then(function (resp) { return resp.json(); });
    };
    MapboxAdapter.prototype.fetchResults = function (essResponse) {
        var _this = this;
        var toEssResponse = function (results) { return ({
            q: essResponse.q,
            rc: essResponse.rc,
            rid: essResponse.rid,
            sr: results
        }); };
        return new Promise(function (resolve) {
            _this.fetchFromMapbox(essResponse.q)
                .then(function (respBody) { return ((respBody === null || respBody === void 0 ? void 0 : respBody.features) === undefined ? [] : respBody.features); })
                .then(function (predictions) {
                return predictions.length === 0 ? resolve(essResponse) : resolve(toEssResponse(_this.handleResponse(predictions)));
            })
                .catch(function () {
                resolve(essResponse);
            });
        });
    };
    MapboxAdapter.prototype.handleResponse = function (predictions) {
        var _this = this;
        var results = [];
        predictions.forEach(function (prediction, index) {
            var placeId = prediction.id.split('.')[1];
            results.push(_this.toEssResult(prediction.place_name, placeId, index));
        });
        return results;
    };
    MapboxAdapter.instances = {};
    return MapboxAdapter;
}(ThirdPartyAdapter));

export { MapboxAdapter };
